import { Text } from '@lmc/ui-kit/src/general'
import styled from 'styled-components'
import type { PayReportRow } from '../types/payReport'
import { getPayReportContractDisplay } from './payReportContractUtils'

type Translate = (key: string, options?: Record<string, unknown>) => string

type PayRateContractPopoverBodyProps = {
  record: PayReportRow
  t: Translate
  resolveContractTypeLabel: (contractTypeId?: string | null) => string
}

function weeklyContractedHoursLabel(
  value: PayReportRow['weeklyContractedHours']
): string {
  if (value == null || value === '') {
    return '-'
  }
  return typeof value === 'number' ? String(value) : value
}

function resolvedWeeklyHours(record: PayReportRow): string {
  if (
    record.contractedHoursPerWeek != null &&
    Number.isFinite(record.contractedHoursPerWeek)
  ) {
    return String(record.contractedHoursPerWeek)
  }
  return weeklyContractedHoursLabel(record.weeklyContractedHours)
}

export const PayRateContractPopoverBody = ({
  record,
  t,
  resolveContractTypeLabel
}: PayRateContractPopoverBodyProps) => {
  const payLine =
    record.payRateCard?.trim() || record.payRateDisplay?.trim() || ''
  const contractLine = getPayReportContractDisplay(
    record,
    resolveContractTypeLabel
  )

  return (
    <PopoverContentContainer>
      <FieldStack>
        <PopoverTitleText level={2}>
          {t('PAY_REPORT_POPOVER_PAY_RATE')}
        </PopoverTitleText>
        <PopoverBodyText>
          {payLine || t('PAY_REPORT_POPOVER_PAY_RATE_EMPTY')}
        </PopoverBodyText>
      </FieldStack>
      <FieldStack>
        <PopoverTitleText level={2}>
          {t('PAY_REPORT_COL_CONTRACT_TYPE')}
        </PopoverTitleText>
        <PopoverBodyText>{contractLine}</PopoverBodyText>
      </FieldStack>
      <FieldStack>
        <PopoverTitleText level={2}>
          {t('PAY_REPORT_POPOVER_WEEKLY_CONTRACTED_HOURS')}
        </PopoverTitleText>
        <PopoverBodyText>{resolvedWeeklyHours(record)}</PopoverBodyText>
      </FieldStack>
    </PopoverContentContainer>
  )
}

const PopoverContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 280px;
  padding: 4px 0;
`

const FieldStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

const PopoverTitleText = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color5};
`

const PopoverBodyText = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color3};
`
